import {
  ArrayField,
  BooleanField,
  ChipField,
  DataTable,
  DateField,
  EditButton,
  FunctionField,
  ImageField,
  NumberField,
  PrevNextButtons,
  ReferenceField,
  SelectField,
  Show,
  SingleFieldList,
  TextField,
  Title,
  TopToolbar,
  useRecordContext,
} from "react-admin";
import { SimpleShowLayout } from "../common/SimpleShowLayout";
import {
  COMMUNITY_POST_STATUS_CHOICES,
  COMMUNITY_POST_TYPES_CHOICES,
} from "../utils/CommunityPostUtils";
import { truncate } from "../utils/StringUtils";

const CommunityPostTitle = () => {
  const record = useRecordContext();
  return <Title title={`Publicación "${truncate(record?.content, 50)}"`} />;
};

const CommunityPostShowActions = () => {
  return (
    <TopToolbar>
      <EditButton />
      <PrevNextButtons linkType="show" />
    </TopToolbar>
  );
};

const CommunityPostShow = () => (
  <Show title={<CommunityPostTitle />} actions={<CommunityPostShowActions />}>
    <SimpleShowLayout>
      <TextField source="content" label="Contenido" />
      <ArrayField source="images" label="Imágenes">
        <DataTable
          storeKey="communityPost.images"
          rowClick={false}
          bulkActionButtons={false}
        >
          <DataTable.Col source="url" label="">
            <ImageField source="url" label="" />
          </DataTable.Col>
        </DataTable>
      </ArrayField>
      <ReferenceField
        label="Restaurante"
        reference="restaurants"
        source="restaurant"
      >
        <TextField source="name" label="Nombre" />
      </ReferenceField>
      <ReferenceField label="Usuario" reference="users" source="user">
        <TextField source="firstName" label="Nombre" />
      </ReferenceField>
      <SelectField
        source="type"
        label="Tipo"
        choices={COMMUNITY_POST_TYPES_CHOICES}
      />
      <ArrayField source="surveyOptions" label="Opciones">
        <DataTable
          storeKey="communityPost.surveyOptions"
          rowClick={false}
          bulkActionButtons={false}
        >
          <DataTable.Col source="option" label="Opción" />
          <DataTable.Col source="votes" label="Votos">
            <NumberField source="votes" label="Votos" />
          </DataTable.Col>
        </DataTable>
      </ArrayField>
      <DateField
        source="surveyDeadline"
        label="Fecha límite"
        showTime
        emptyText="-"
      />
      <BooleanField source="pinned" label="Fijado" />
      <ArrayField label="Países" source="countries">
        <SingleFieldList linkType={false}>
          <FunctionField
            render={(record) => (
              <ChipField record={{ name: record }} source="name" size="small" />
            )}
          />
        </SingleFieldList>
      </ArrayField>
      <SelectField
        source="status"
        label="Estado"
        choices={COMMUNITY_POST_STATUS_CHOICES}
      />
    </SimpleShowLayout>
  </Show>
);

export default CommunityPostShow;
